import { DatePicker, MonthPicker, Popover } from "@xola/ui-kit";
import clsx from "clsx";
import { Dayjs } from "dayjs";
import React from "react";
import { useVisibility } from "@/hooks/useVisibility";
import { useDashboardFilterStore } from "@/stores/dashboardFilterStore";
import { DashboardMode } from "@/types/Dashboard";

interface DashboardDatePickerPopoverProps {
    children: React.ReactNode;
    date: Dayjs;
    selectedDays?: {
        from: Date;
        to: Date;
    };
    onChange?: (date: Date) => void;
}

export const DashboardDatePickerPopover = ({
    children,
    date,
    selectedDays,
    onChange,
}: DashboardDatePickerPopoverProps) => {
    const [visible, { toggle, hide }] = useVisibility(false);
    const mode = useDashboardFilterStore().filters.mode;
    const handleDateChange = (date: Date) => {
        onChange?.(date);
        hide();
    };

    return (
        <Popover
            appendTo={document.body}
            maxWidth={900}
            distance={18}
            visible={visible}
            placement="bottom"
            className={clsx("ui-date-picker-input p-3")}
            onClickOutside={hide}
        >
            <span onClick={toggle}>{children}</span>
            <Popover.Content className="pr-1">
                {mode === DashboardMode.MONTH ? (
                    <MonthPicker value={date.toDate()} onChange={handleDateChange} />
                ) : (
                    <DatePicker
                        shouldShowMonthSelector
                        value={date.toDate()}
                        selectedDays={selectedDays}
                        onChange={handleDateChange}
                    />
                )}
            </Popover.Content>
        </Popover>
    );
};
